export default __webpack_public_path__ + "assets/Lato-Italic.a9f3ee269217f44df65fe7e3379266f4.ttf";